function SearchIcon() {
    return (
        <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--cpm-text-tertiary)"
            strokeWidth="2"
        >
            <circle cx="11" cy="11" r="7" />
            <path d="m21 21-4.35-4.35" strokeLinecap="round" />
        </svg>
    );
}

interface SearchFieldProps {
    value: string;
    onChange: (next: string) => void;
    placeholder: string;
    disabled?: boolean;
    width?: number;
    size?: 'sm' | 'md';
    onFocus?: () => void;
}

export default function SearchField({
    value,
    onChange,
    placeholder,
    disabled = false,
    width = 330,
    size = 'md',
    onFocus,
}: SearchFieldProps) {
    return (
        <label
            className="inline-flex items-center bg-white"
            style={{
                width,
                maxWidth: '100%',
                height: size === 'sm' ? 36 : 38,
                gap: 8,
                padding: '0 12px',
                borderRadius: 10,
                border: '1.5px solid var(--cpm-border-strong)',
                opacity: disabled ? 0.6 : 1,
            }}
        >
            <SearchIcon />
            <input
                value={value}
                disabled={disabled}
                placeholder={placeholder}
                onFocus={onFocus}
                onChange={(e) => onChange(e.target.value)}
                className="flex-1 min-w-0 bg-transparent border-0 outline-none"
                style={{ fontSize: 13, fontWeight: 600, color: 'var(--cpm-text-primary)' }}
            />
        </label>
    );
}
